import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiListItemIcon(_theme: Theme): MuiThemeComponentOverride<"MuiListItemIcon"> {
  return { MuiListItemIcon: { styleOverrides: { root: { minWidth: "unset" } } } };
}
